import { render, staticRenderFns } from "./Kasir.vue?vue&type=template&id=152381db&"
import script from "./Kasir.vue?vue&type=script&lang=js&"
export * from "./Kasir.vue?vue&type=script&lang=js&"
import style0 from "./Kasir.vue?vue&type=style&index=0&id=152381db&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports